module.exports = __webpack_public_path__ + "media/julio_toolbar.32339d49.mp4";